/** Shared Redux action types for product catalog state (avoids products/settings circular imports). */
export const RECEIVED_CATEGORIES = 'RECEIVED_CATEGORIES';
export const RECEIVED_PRODUCT_DEFAULTS = 'RECEIVED_PRODUCT_DEFAULTS';
